export default function initLatestArticlesCarousel(Swiper, Autoplay) {
    // ==========================================================
    // LATEST ARTICLES SWIPER
    // ==========================================================

    const articleSliders = document.querySelectorAll(".latest-articles__slider");

    articleSliders.forEach((slider) => {
        const section = slider.closest(".latest-articles");

        if (!section) {
            return;
        }

        const tabs = section.querySelectorAll(".latest-articles__tab[data-article-index]");

        const dots = section.querySelectorAll(".latest-articles__dot[data-article-dot]");

        // ======================================================
        // NAVIGATION ACTIVE
        // ======================================================

        const updateNavigation = (index) => {
            tabs.forEach((tab) => {
                const tabIndex = Number(tab.dataset.articleIndex);

                tab.classList.toggle("is-active", tabIndex === index);
            });

            dots.forEach((dot) => {
                const dotIndex = Number(dot.dataset.articleDot);

                dot.classList.toggle("is-active", dotIndex === index);
            });
        };

        // ======================================================
        // SWIPER
        // ======================================================

        const swiper = new Swiper(slider, {
            modules: [Autoplay],
            slidesPerView: 1.05,
            spaceBetween: 16,

            loop: true,
            watchOverflow: true,
            autoplay: {
                delay: 2500,
                disableOnInteraction: false,
                pauseOnMouseEnter: true,
            },

            breakpoints: {
                640: {
                    slidesPerView: 1.2,
                    spaceBetween: 20,
                },

                768: {
                    slidesPerView: 1.5,
                    spaceBetween: 24,
                },

                1024: {
                    slidesPerView: 1.5,
                    spaceBetween: 24,
                },

                1300: {
                    slidesPerView: 1.5,
                    spaceBetween: 24,
                },
            },

            on: {
                init(swiperInstance) {
                    updateNavigation(swiperInstance.realIndex);
                },

                slideChange(swiperInstance) {
                    updateNavigation(swiperInstance.realIndex);
                },
            },
        });

        // ======================================================
        // TABS ARTICLE 1 / ARTICLE 2 / ARTICLE 3
        // ======================================================

        tabs.forEach((tab) => {
            tab.addEventListener("click", () => {
                const index = Number(tab.dataset.articleIndex);

                /**
                 * On change immédiatement l'état visuel.
                 */
                updateNavigation(index);

                /**
                 * Puis on déplace Swiper.
                 */
                swiper.slideTo(index);
            });
        });

        // ======================================================
        // DOTS
        // ======================================================

        dots.forEach((dot) => {
            dot.addEventListener("click", () => {
                const index = Number(dot.dataset.articleDot);

                updateNavigation(index);

                swiper.slideTo(index);
            });
        });
    });
}